// import React, { useState, useEffect } from 'react';
// import {
//   Table,
//   Button,
//   Form,
//   Row,
//   Col,
//   Card,
//   Badge,
//   Modal,
//   Pagination,
//   Dropdown,
//   ButtonGroup,
//   Spinner,
//   Alert,
//   InputGroup
// } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import ApplicantProfile from './ApplicantProfile';

// // Reuse react-bootstrap Modal inline to avoid breaking structure
// const SendEmailModal = ({ show, onHide, domain, selectedApplicants, applicants, onSent, allFiltered }) => {
//   const [templates, setTemplates] = React.useState([]);
//   const [loading, setLoading] = React.useState(false);
//   const [selectedTemplate, setSelectedTemplate] = React.useState(null);
//   const [preview, setPreview] = React.useState({ subject: '', body: '' });
//   const [confirming, setConfirming] = React.useState(false);
//   const [editMode, setEditMode] = React.useState(false);
//   const [savingTemplate, setSavingTemplate] = React.useState(false);
//   const [rawSubject, setRawSubject] = React.useState('');
//   const [rawBody, setRawBody] = React.useState('');
//   const [showPreview, setShowPreview] = React.useState(true);
//   const [templateName, setTemplateName] = React.useState('');

//   React.useEffect(() => {
//     if (!show) return;
//     (async () => {
//       try {
//         const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
//         const res = await axios.get(`${base}/api/email/templates`, { withCredentials: true });
//         setTemplates(res.data.templates || []);
//       } catch (e) {
//         setTemplates([]);
//       }
//     })();
//   }, [show]);

//   React.useEffect(() => {
//     const tpl = templates.find(t => t.id === selectedTemplate);
//     if (tpl) {
//       setPreview({ subject: tpl.subject, body: tpl.body });
//       setRawSubject(tpl.subject);
//       setRawBody(tpl.body);
//       setTemplateName(tpl.template_name || '');
//     } else {
//       setPreview({ subject: '', body: '' });
//       setRawSubject('');
//       setRawBody('');
//       setTemplateName('');
//     }
//   }, [selectedTemplate, templates]);

//   const handleSaveTemplate = async () => {
//     try {
//       if (!templateName || !rawSubject || !rawBody) {
//         toast.warn('Please fill template name, subject and body');
//         return;
//       }
//       setSavingTemplate(true);
//       const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
//       const payload = {
//         id: selectedTemplate || undefined,
//         template_name: templateName,
//         subject: rawSubject,
//         body: rawBody
//       };
//       const res = await axios.post(`${base}/api/email/save-template`, payload, { withCredentials: true });
//       const saved = res.data.template;
//       setTemplates(prev => {
//         const exists = prev.some(t => t.id === saved.id);
//         if (exists) {
//           return prev.map(t => t.id === saved.id ? saved : t);
//         }
//         return [saved, ...prev];
//       });
//       setSelectedTemplate(saved.id);
//       setPreview({ subject: saved.subject, body: saved.body });
//       toast.success(`Template ${res.data.action === 'created' ? 'created' : 'updated'} successfully!`);
//       setEditMode(false);
//     } catch (e) {
//       toast.error('Error saving template.');
//     } finally {
//       setSavingTemplate(false);
//     }
//   };

//   // Build email list from all filtered + selected
//   const applicantEmails = React.useMemo(() => {
//     const sel = new Set(selectedApplicants);
//     const base = Array.isArray(allFiltered) && allFiltered.length ? allFiltered : applicants;
//     const emails = [];
//     (base || []).forEach(a => {
//       const ats = a.ats_number;
//       if (!sel.has(ats)) return;
//       const email = a.email_id;
//       if (!email) return;
//       emails.push(email);
//     });
//     return emails;
//   }, [selectedApplicants, applicants, allFiltered]);

//   const handleSend = async () => {
//     if (!selectedTemplate) return;
//     setConfirming(true);
//   };

//   const confirmSend = async () => {
//     try {
//       setLoading(true);
//       const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
//       const res = await axios.post(`${base}/api/email/send-domain`, {
//         domain: domain || 'General',
//         template_id: selectedTemplate,
//         email_list: applicantEmails
//       }, { withCredentials: true });
//       onSent && onSent(res.data);
//       setConfirming(false);
//       onHide();
//     } catch (e) {
//       onSent && onSent({ success: false, sent: 0, failed: [{ error: e.message }] });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Modal show={show} onHide={onHide} size="lg" centered>
//       <Modal.Header closeButton>
//         <Modal.Title>Send Emails{domain ? ` — ${domain}` : ''}</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Row className="mb-3">
//           <Col md={6}>
//             <Form.Group>
//               <Form.Label>Email Template</Form.Label>
//               <Form.Select value={selectedTemplate || ''} onChange={e => setSelectedTemplate(Number(e.target.value))}>
//                 <option value="">Select a template</option>
//                 {templates.map(t => (
//                   <option key={t.id} value={t.id}>{t.template_name}</option>
//                 ))}
//               </Form.Select>
//             </Form.Group>
//           </Col>
//           <Col md={6} className="d-flex align-items-end justify-content-end">
//             <div className="text-end w-100">
//               <div className="small text-muted">Recipients: {applicantEmails.length}</div>
//               <div className="d-flex gap-2 mt-2 justify-content-end">
//                 <Button variant={editMode ? 'outline-secondary' : 'outline-primary'} size="sm" onClick={() => setEditMode(m => !m)}>
//                   {editMode ? 'Cancel Edit' : 'Edit Template'}
//                 </Button>
//                 <Button variant={showPreview ? 'outline-secondary' : 'outline-primary'} size="sm" disabled={!selectedTemplate && !editMode} onClick={() => setShowPreview(p => !p)}>
//                   {showPreview ? 'Hide Preview' : 'Show Preview'}
//                 </Button>
//                 <Button variant="primary" size="sm" onClick={handleSend} disabled={!selectedTemplate || applicantEmails.length === 0}>
//                   Send Email
//                 </Button>
//               </div>
//             </div>
//           </Col>
//         </Row>
//         {(editMode) && (
//           <Card className="mb-3">
//             <Card.Body>
//               <Row>
//                 <Col md={6}>
//                   <Form.Group className="mb-3">
//                     <Form.Label>Template Name</Form.Label>
//                     <Form.Control value={templateName} onChange={e => setTemplateName(e.target.value)} placeholder="e.g., Node.js Meet & Greet Invite" />
//                   </Form.Group>
//                 </Col>
//               </Row>
//               <Form.Group className="mb-3">
//                 <Form.Label>Subject</Form.Label>
//                 <Form.Control value={rawSubject} onChange={e => setRawSubject(e.target.value)} placeholder="Invitation – Meet & Greet Session" />
//               </Form.Group>
//               <Form.Group className="mb-3">
//                 <Form.Label>Body</Form.Label>
//                 <Form.Control as="textarea" rows={8} value={rawBody} onChange={e => setRawBody(e.target.value)} placeholder={"Dear Candidate,\n\nYou are invited to our session.\n\nRegards,\nHR Team\nStartupWorld"} />
//               </Form.Group>
//               <div className="text-end">
//                 <Button className="btn-save-template" variant="success" size="sm" disabled={savingTemplate} onClick={handleSaveTemplate}>
//                   {savingTemplate ? <Spinner animation="border" size="sm" /> : 'Save Template'}
//                 </Button>
//               </div>
//             </Card.Body>
//           </Card>
//         )}
//         {showPreview && (selectedTemplate || (editMode && (rawSubject || rawBody))) && (
//           <Card>
//             <Card.Body>
//               <div className="mb-2"><strong>Subject:</strong> {editMode ? rawSubject : preview.subject}</div>
//               <div>
//                 <strong>Preview:</strong>
//                 <pre style={{ whiteSpace: 'pre-wrap', background:'#f8f9fa', padding:12, borderRadius:6 }}>{editMode ? rawBody : preview.body}</pre>
//               </div>
//             </Card.Body>
//           </Card>
//         )}

//         <Modal show={confirming} onHide={() => setConfirming(false)} centered>
//           <Modal.Header closeButton>
//             <Modal.Title>Confirm Send</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             Are you sure you want to send emails to {applicantEmails.length} applicants?
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="secondary" onClick={() => setConfirming(false)}>Cancel</Button>
//             <Button variant="primary" onClick={confirmSend} disabled={loading} className="btn-send-confirm">
//               {loading ? <Spinner animation="border" size="sm" /> : 'Yes, Send'}
//             </Button>
//           </Modal.Footer>
//         </Modal>
//       </Modal.Body>
//     </Modal>
//   );
// };

// const ApplicantsList = () => {
//   const [applicants, setApplicants] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [sources, setSources] = useState([]);
//   const [filters, setFilters] = useState({
//     search: '',
//     status: '',
//     source: '',
//     application_date: null,
//     meet_greet_date: null
//   });
//   const [pagination, setPagination] = useState({
//     page: 1,
//     limit: 10,
//     total: 0,
//     totalPages: 0
//   });
//   const [selectedApplicants, setSelectedApplicants] = useState([]);
//   const [allFiltered, setAllFiltered] = useState([]); // full filtered set across pages
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [deleteLoading, setDeleteLoading] = useState(false);
//   const [showProfileModal, setShowProfileModal] = useState(false);
//   const [selectedApplicantAts, setSelectedApplicantAts] = useState(null);
//   const [showEmailModal, setShowEmailModal] = useState(false);
//   const [domains, setDomains] = useState([]);
//   const [selectedDomain, setSelectedDomain] = useState('');

//   useEffect(() => {
//     fetchApplicants();
//     fetchSources();
//   }, [filters, pagination.page]);

//   useEffect(() => {
//     // Load domains for filter and email modal context
//     (async () => {
//       try {
//         const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
//         const res = await axios.get(`${base}/api/domains`, { withCredentials: true });
//         setDomains(res.data || []);
//       } catch (e) {
//         setDomains([]);
//       }
//     })();
//   }, []);

//   const formatDateToLocal = (date) => {
//   if (!date) return null;
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
//   const day = String(date.getDate()).padStart(2, '0');
//   return `${year}-${month}-${day}`;
// };

// const fetchApplicants = async () => {
//   try {
//     setLoading(true);
//     setError(null);

//     const params = {
//       page: pagination.page,
//       limit: pagination.limit,
//       ...filters,
//       application_date: formatDateToLocal(filters.application_date),
//       meet_greet_date: formatDateToLocal(filters.meet_greet_date),
//     };

//     const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
//     const response = await axios.get(`${base}/api/applicants`, { params, withCredentials: true });

//     if (response.data && response.data.data) {
//       setApplicants(response.data.data);
//       setAllFiltered(response.data.allFiltered || []);
//       setPagination(prev => ({
//         ...prev,
//         total: response.data.pagination?.total || 0,
//         totalPages: response.data.pagination?.totalPages || 0
//       }));
//     } else {
//       setApplicants([]);
//       setAllFiltered([]);
//       setPagination(prev => ({
//         ...prev,
//         total: 0,
//         totalPages: 0
//       }));
//     }
//   } catch (error) {
//     console.error('Error fetching applicants:', error);
//     setError('Failed to load applicants. Please try again.');
//     toast.error('Failed to load applicants');
//   } finally {
//     setLoading(false);
//   }
// };
//   const fetchSources = async () => {
//     try {
//     const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
//   const response = await axios.get(`${base}/api/applicants/sources`, { withCredentials: true });
//       setSources(response.data || []);
//     } catch (error) {
//       console.error('Error fetching sources:', error);
//       // Fallback to common sources if API fails
//       setSources(['AICTE', 'LinkedIn', 'Instagram', 'Direct', 'Referral', 'Website', 'Other']);
//     }
//   };

//   const handleFilterChange = (field, value) => {
//     setFilters(prev => ({ ...prev, [field]: value }));
//     setPagination(prev => ({ ...prev, page: 1 }));
//   };

//   const handlePageChange = (page) => {
//     setPagination(prev => ({ ...prev, page }));
//   };

//   const handleSelectAllPage = (checked) => {
//     if (checked) {
//       const pageIds = applicants.map(a => a.ats_number);
//       setSelectedApplicants(prev => Array.from(new Set([...prev, ...pageIds])));
//     } else {
//       const pageIds = new Set(applicants.map(a => a.ats_number));
//       setSelectedApplicants(prev => prev.filter(id => !pageIds.has(id)));
//     }
//   };

//   const handleSelectAllFiltered = () => {
//     const allIds = allFiltered.map(x => x.ats_number);
//     setSelectedApplicants(allIds);
//     toast.success(`All ${allIds.length} filtered applicants selected`);
//   };

//   const handleUnselectAll = () => {
//     setSelectedApplicants([]);
//   };

//   const handleSelectApplicant = (atsNumber, checked) => {
//     if (checked) {
//       setSelectedApplicants(prev => [...prev, atsNumber]);
//     } else {
//       setSelectedApplicants(prev => prev.filter(id => id !== atsNumber));
//     }
//   };

//   const handleDeleteApplicant = async (atsNumber) => {
//     try {
//     const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
//   await axios.delete(`${base}/api/applicants/${atsNumber}`, { withCredentials: true });
//       toast.success('Applicant deleted successfully');
//       fetchApplicants();
//     } catch (error) {
//       console.error('Error deleting applicant:', error);
//       toast.error('Failed to delete applicant');
//     }
//   };

//   const handleViewApplicant = (atsNumber) => {
//     setSelectedApplicantAts(atsNumber);
//     setShowProfileModal(true);
//   };

//   const handleBulkDelete = async () => {
//     if (selectedApplicants.length === 0) {
//       toast.warning('Please select applicants to delete');
//       return;
//     }

//     setDeleteLoading(true);
//     try {
//       for (const atsNumber of selectedApplicants) {
//     const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
//   await axios.delete(`${base}/api/applicants/${atsNumber}`, { withCredentials: true });
//       }
//       toast.success(`${selectedApplicants.length} applicants deleted successfully`);
//       setSelectedApplicants([]);
//       setShowDeleteModal(false);
//       fetchApplicants();
//     } catch (error) {
//       console.error('Error bulk deleting applicants:', error);
//       toast.error('Failed to delete some applicants');
//     } finally {
//       setDeleteLoading(false);
//     }
//   };

//   const getStatusBadge = (applicant) => {
//     if (applicant.rejected) return <Badge bg="danger">Rejected</Badge>;
//     if (applicant.left) return <Badge bg="warning" text="dark">Left</Badge>;
//     if (applicant.assigned_project) return <Badge bg="success">Assigned</Badge>;
//     if (applicant.registered_startupworld) return <Badge bg="info">Registered</Badge>;
//     if (applicant.attended_meet_greet) return <Badge bg="primary">Attended</Badge>;
//     return <Badge bg="secondary">New</Badge>;
//   };

//   const clearFilters = () => {
//     setFilters({
//       search: '',
//       status: '',
//       source: '',
//       application_date: null,
//       meet_greet_date: null
//     });
//     setPagination(prev => ({ ...prev, page: 1 }));
//   };

//   return (
//     <div className="applicants-container">
//       {/* Header */}
//       <div className="applicants-header">
//         <div className="header-content">
//           <h1>Applicants Management</h1>
//           <p>Manage and track all applicant information</p>
//         </div>
//         <div className="header-actions">
//           <Link to="/applicants/new">
//             <Button variant="primary" className="add-btn">
//               Add New Applicant
//             </Button>
//           </Link>
//           <Link to="/bulk-upload">
//             <Button variant="outline-primary" className="upload-btn">
//               Bulk Upload
//             </Button>
//           </Link>
//           <Link to="/reject-upload">
//             <Button variant="outline-danger" className="upload-btn ms-2">
//               Upload Rejected
//             </Button>
//           </Link>
//         </div>
//       </div>

//       {/* Filters */}
//       <Card className="filters-card">
//         <Card.Body>
//           <Row>
//             <Col md={3}>
//               <Form.Group>
//                 <Form.Label>Search</Form.Label>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by name, email, ATS number..."
//                   value={filters.search}
//                   onChange={(e) => handleFilterChange('search', e.target.value)}
//                 />
//               </Form.Group>
//             </Col>
//             <Col md={2}>
//               <Form.Group>
//                 <Form.Label>Status</Form.Label>
//                 <Form.Select
//                   value={filters.status}
//                   onChange={(e) => handleFilterChange('status', e.target.value)}
//                 >
//                   <option value="">All Status</option>
//                   <option value="attended">Attended</option>
//                   <option value="registered">Registered</option>
//                   <option value="assigned">Assigned</option>
//                   <option value="rejected">Rejected</option>
//                   <option value="left">Left</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//             <Col md={2}>
//               <Form.Group>
//                 <Form.Label>Domain</Form.Label>
//                 <Form.Select
//                   value={filters.domain || ''}
//                   onChange={(e) => {
//                     setSelectedDomain(e.target.value);
//                     handleFilterChange('domain', e.target.value);
//                   }}
//                 >
//                   <option value="">All Domains</option>
//                   {domains.map(d => (
//                     <option key={d} value={d}>{d}</option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//             <Col md={2}>
//               <Form.Group>
//                 <Form.Label>Source</Form.Label>
//                 <Form.Select
//                   value={filters.source}
//                   onChange={(e) => handleFilterChange('source', e.target.value)}
//                 >
//                   <option value="">All Sources</option>
//                   {sources.map(source => (
//                     <option key={source} value={source}>{source}</option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//             <Col md={2}>
//               <Form.Group>
//                 <Form.Label>Application Date</Form.Label>
//                 <DatePicker
//                   selected={filters.application_date}
//                   onChange={(date) => handleFilterChange('application_date', date)}
//                   className="form-control"
//                   placeholderText="Select date"
//                   dateFormat="yyyy-MM-dd"
//                 />
//               </Form.Group>
//             </Col>
//             <Col md={2}>
//               <Form.Group>
//                 <Form.Label>M&G Date</Form.Label>
//                 <DatePicker
//                   selected={filters.meet_greet_date}
//                   onChange={(date) => handleFilterChange('meet_greet_date', date)}
//                   className="form-control"
//                   placeholderText="Select date"
//                   dateFormat="yyyy-MM-dd"
//                 />
//               </Form.Group>
//             </Col>
//             <Col md={1}>
//               <Form.Group>
//                 <Form.Label>&nbsp;</Form.Label>
//                 <Button
//                   variant="outline-secondary"
//                   onClick={clearFilters}
//                   className="w-100"
//                 >
//                   Clear
//                 </Button>
//               </Form.Group>
//             </Col>
            
//           </Row>
//         </Card.Body>
//       </Card>

//       {/* Results Summary */}
//       <div className="results-summary">
//         <div className="summary-info">
//           <span className="total-count">
//             Total: {pagination.total} applicants
//           </span>
//           <span className="selected-count">
//             Selected: {selectedApplicants.length}
//           </span>
//         </div>
//         <div className="bulk-actions d-flex gap-2">
//           <Button
//             variant="outline-secondary"
//             size="sm"
//             onClick={handleSelectAllFiltered}
//             disabled={(allFiltered.length === 0) || selectedApplicants.length === allFiltered.length}
//           >
//             Select All Filtered ({allFiltered.length})
//           </Button>
//           <Button
//             variant="outline-secondary"
//             size="sm"
//             onClick={handleUnselectAll}
//             disabled={selectedApplicants.length === 0}
//           >
//             Unselect All
//           </Button>
//           <Button
//             variant="primary"
//             size="sm"
//             onClick={() => setShowEmailModal(true)}
//             disabled={selectedApplicants.length === 0}
//           >
//             Send Email
//           </Button>
//           <Button
//             variant="outline-danger"
//             size="sm"
//             onClick={() => setShowDeleteModal(true)}
//             disabled={selectedApplicants.length === 0}
//           >
//             Delete Selected
//           </Button>
//         </div>
//       </div>

//       {/* Applicants Table */}
//       <Card className="table-card">
//         <Card.Body className="p-0">
//           {loading ? (
//             <div className="loading-container">
//               <Spinner animation="border" role="status">
//                 <span className="visually-hidden">Loading...</span>
//               </Spinner>
//               <p>Loading applicants...</p>
//             </div>
//           ) : error ? (
//             <Alert variant="danger" className="m-3">
//               {error}
//             </Alert>
//           ) : applicants.length === 0 ? (
//             <div className="empty-state">
//               <p>No applicants found</p>
//               <Link to="/applicants/new">
//                 <Button variant="primary">Add First Applicant</Button>
//               </Link>
//             </div>
//           ) : (
//             <div className="table-responsive">
//               <Table hover className="applicants-table">
//                 <thead>
//                   <tr>
//                     <th>
//                       <Form.Check
//                         type="checkbox"
//                         checked={applicants.every(a => selectedApplicants.includes(a.ats_number)) && applicants.length>0}
//                         onChange={(e) => handleSelectAllPage(e.target.checked)}
//                       />
//                     </th>
//                     <th>ATS Number</th>
//                     <th>Name</th>
//                     <th>Contact</th>
//                     <th>Domain</th>
//                     <th>Internship UID</th>
//                     <th>Source</th>
//                     <th>Application Date</th>
//                     <th>Status</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {applicants.map((applicant) => (
//                     <tr key={applicant.id} className={selectedApplicants.includes(applicant.ats_number) ? 'selected-row' : ''}>
//                       <td>
//                         <Form.Check
//                           type="checkbox"
//                           checked={selectedApplicants.includes(applicant.ats_number)}
//                           onChange={(e) =>
//                             handleSelectApplicant(applicant.ats_number, e.target.checked)
//                           }
//                         />
//                       </td>
//                       <td>
//                         <span className="ats-number">{applicant.ats_number}</span>
//                       </td>

//                       <td>
//                         <div className="applicant-name">
//                           <strong>
//                             {applicant.first_name} {applicant.last_name}
//                           </strong>
//                         </div>
//                       </td>

//                       <td>
//                         <div className="contact-info">
//                           <div className="email">{applicant.email_id}</div>
//                           <div className="phone">
//                             {applicant.country_code} {applicant.phone_number}
//                           </div>
//                         </div>
//                       </td>

//                       <td>
//                         <span className="domain">{applicant.domain || 'N/A'}</span>
//                       </td>

//                       {/* ✅ Intern ID column (fixed) */}
//                       <td>
//                         <span className="intern-id">{applicant.internship_uid || 'N/A'}</span>
//                       </td>

//                       {/* ✅ Source column (separate td, not inside Intern ID) */}
//                       <td>
//                         <span className="source">{applicant.source || 'Unknown'}</span>
//                       </td>

//                       <td>
//                         <span className="date">{applicant.application_date}</span>
//                       </td>

//                       <td>{getStatusBadge(applicant)}</td>

//                       <td>
//                         <div className="action-buttons">
//                           <Button
//                             variant="outline-primary"
//                             size="sm"
//                             onClick={() => handleViewApplicant(applicant.ats_number)}
//                           >
//                             View
//                           </Button>
//                           <Link to={`/applicants/${applicant.ats_number}/edit`}>
//                             <Button variant="outline-secondary" size="sm">Edit</Button>
//                           </Link>
//                           {applicant.resume_link && (
//                             <Button
//                               variant="outline-info"
//                               size="sm"
//                               href={applicant.resume_link}
//                               target="_blank"
//                             >
//                               Resume
//                             </Button>
//                           )}
//                           <Button
//                             variant="outline-danger"
//                             size="sm"
//                             onClick={() => handleDeleteApplicant(applicant.ats_number)}
//                           >
//                             Delete
//                           </Button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </div>
//           )}
//         </Card.Body>
//       </Card>

//       {/* Pagination */}
//       {pagination.totalPages > 1 && (
//         <div className="pagination-container">
//           <Pagination>
//             <Pagination.First
//               onClick={() => handlePageChange(1)}
//               disabled={pagination.page === 1}
//             />
//             <Pagination.Prev
//               onClick={() => handlePageChange(Math.max(1, pagination.page - 1))}
//               disabled={pagination.page === 1}
//             />

//             {/* Sliding window of up to 5 pages */}
//             {(() => {
//               const pages = [];
//               const maxVisible = 5;
//               // center current page where possible
//               let start = Math.max(1, pagination.page - Math.floor(maxVisible / 2));
//               let end = start + maxVisible - 1;

//               if (end > pagination.totalPages) {
//                 end = pagination.totalPages;
//                 start = Math.max(1, end - maxVisible + 1);
//               }

//               // optional: show first page + ellipsis when start > 1
//               if (start > 1) {
//                 pages.push(
//                   <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
//                     {1}
//                   </Pagination.Item>
//                 );
//                 if (start > 2) {
//                   pages.push(
//                     <Pagination.Ellipsis key="start-ellipsis" disabled />
//                   );
//                 }
//               }

//               for (let p = start; p <= end; p++) {
//                 pages.push(
//                   <Pagination.Item
//                     key={p}
//                     active={p === pagination.page}
//                     onClick={() => handlePageChange(p)}
//                   >
//                     {p}
//                   </Pagination.Item>
//                 );
//               }

//               // optional: show last page + ellipsis when end < totalPages
//               if (end < pagination.totalPages) {
//                 if (end < pagination.totalPages - 1) {
//                   pages.push(
//                     <Pagination.Ellipsis key="end-ellipsis" disabled />
//                   );
//                 }
//                 pages.push(
//                   <Pagination.Item
//                     key={pagination.totalPages}
//                     onClick={() => handlePageChange(pagination.totalPages)}
//                   >
//                     {pagination.totalPages}
//                   </Pagination.Item>
//                 );
//               }

//               return pages;
//             })()}

//             <Pagination.Next
//               onClick={() => handlePageChange(Math.min(pagination.totalPages, pagination.page + 1))}
//               disabled={pagination.page === pagination.totalPages}
//             />
//             <Pagination.Last
//               onClick={() => handlePageChange(pagination.totalPages)}
//               disabled={pagination.page === pagination.totalPages}
//             />
//           </Pagination>
//         </div>
//       )}

//       {/* Delete Confirmation Modal */}
//       <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Delete</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Are you sure you want to delete {selectedApplicants.length} selected applicant(s)?
//           This action cannot be undone.
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
//             Cancel
//           </Button>
//           <Button
//             variant="danger"
//             onClick={handleBulkDelete}
//             disabled={deleteLoading}
//           >
//             {deleteLoading ? <Spinner animation="border" size="sm" /> : 'Delete'}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Applicant Profile Modal */}
//       <ApplicantProfile
//         show={showProfileModal}
//         onHide={() => setShowProfileModal(false)}
//         atsNumber={selectedApplicantAts}
//       />

//       {/* Send Email Modal */}
//       <SendEmailModal
//         show={showEmailModal}
//         onHide={() => setShowEmailModal(false)}
//         domain={selectedDomain}
//         selectedApplicants={selectedApplicants}
//         applicants={applicants}
//         allFiltered={allFiltered}
//         onSent={(res) => {
//           if (res && res.success) {
//             toast.success(`✅ Email successfully sent to ${res.sent} applicants.`);
//           } else if (res) {
//             const failed = (res.failed || []).map(f => f.to).filter(Boolean).join(', ');
//             toast.error(`Some emails failed. ${failed ? 'Failed: ' + failed : ''}`);
//           }
//         }}
//       />

//       <style jsx>{`
//         .applicants-container {
//           padding: 24px;
//           background-color: #f8f9fa;
//           min-height: 100vh;
//         }

//         .applicants-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: flex-start;
//           margin-bottom: 24px;
//           background: white;
//           padding: 24px;
//           border-radius: 8px;
//           box-shadow: 0 2px 4px rgba(0,0,0,0.1);
//         }

//         .header-content h1 {
//           margin: 0 0 8px 0;
//           color: #2c3e50;
//           font-size: 28px;
//           font-weight: 600;
//         }

//         .header-content p {
//           margin: 0;
//           color: #6c757d;
//           font-size: 16px;
//         }

//         .header-actions {
//           display: flex;
//           gap: 12px;
//         }

//         .add-btn, .upload-btn {
//           padding: 10px 20px;
//           font-weight: 500;
//         }

//         .filters-card {
//           margin-bottom: 24px;
//           border: none;
//           box-shadow: 0 2px 4px rgba(0,0,0,0.1);
//         }

//         .filters-card .card-body {
//           padding: 20px;
//         }

//         .results-summary {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 16px;
//           padding: 16px 20px;
//           background: white;
//           border-radius: 8px;
//           box-shadow: 0 2px 4px rgba(0,0,0,0.1);
//         }

//         .summary-info {
//           display: flex;
//           gap: 20px;
//           align-items: center;
//         }

//         .total-count {
//           font-weight: 600;
//           color: #2c3e50;
//         }

//         .selected-count {
//           color: #007bff;
//           font-weight: 500;
//         }

//         .table-card {
//           border: none;
//           box-shadow: 0 2px 4px rgba(0,0,0,0.1);
//           margin-bottom: 24px;
//         }

//         .applicants-table {
//           margin: 0;
//         }

//         .applicants-table th {
//           background-color: #f8f9fa;
//           border-bottom: 2px solid #dee2e6;
//           font-weight: 600;
//           color: #495057;
//           padding: 16px 12px;
//         }

//         .applicants-table td {
//           padding: 16px 12px;
//           vertical-align: middle;
//           border-bottom: 1px solid #f1f3f4;
//         }

//         .applicants-table tbody tr:hover {
//           background-color: #f8f9fa;
//         }

//         .applicants-table tbody tr.selected-row {
//           background-color: #e6f2ff !important;
//         }

//         .ats-number {
//           font-family: 'Courier New', monospace;
//           font-weight: 600;
//           color: #007bff;
//           background: #e3f2fd;
//           padding: 4px 8px;
//           border-radius: 4px;
//           font-size: 14px;
//         }

//         .applicant-name strong {
//           color: #2c3e50;
//           font-size: 16px;
//         }

//         .contact-info {
//           font-size: 14px;
//         }

//         .contact-info .email {
//           color: #007bff;
//           font-weight: 500;
//         }

//         .contact-info .phone {
//           color: #6c757d;
//           margin-top: 2px;
//         }

//         .domain,.intern-id,.source {
//           background: #f8f9fa;
//           padding: 4px 8px;
//           border-radius: 4px;
//           font-size: 14px;
//           color: #495057;
//         }
        
//         .date {
//           color: #6c757d;
//           font-size: 14px;
//         }

//         .action-buttons {
//           display: flex;
//           gap: 4px;
//           flex-wrap: wrap;
//         }

//         .action-buttons .btn {
//           font-size: 12px;
//           padding: 4px 8px;
//         }

//         .loading-container {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           padding: 60px 20px;
//           color: #6c757d;
//         }

//         .empty-state {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           padding: 60px 20px;
//           color: #6c757d;
//         }

//         .empty-state p {
//           margin-bottom: 16px;
//           font-size: 18px;
//         }

//         .pagination-container {
//           display: flex;
//           justify-content: center;
//           margin-top: 24px;
//         }

//         /* Pagination - improved visibility for active page */
// .pagination-container {
//   display: flex;
//   justify-content: center;
//   margin-top: 24px;
// }

// /* base page link */
// .pagination .page-link {
//   color: #007bff;
//   border: 1px solid #dee2e6;
//   background: #fff;
//   min-width: 40px;
//   text-align: center;
//   padding: 6px 10px;
//   margin: 0 2px;
//   border-radius: 6px;
//   font-weight: 500;
// }

// /* active item */
// .pagination .page-item.active .page-link {
//   background-color: #007bff !important;
//   border-color: #007bff !important;
//   color: #ffffff !important;
//   box-shadow: 0 4px 10px rgba(0, 123, 255, 0.15);
// }

// /* disabled look */
// .pagination .page-item.disabled .page-link {
//   color: #6c757d;
//   background-color: #fff;
//   border-color: #dee2e6;
//   opacity: 0.9;
// }

// /* make ellipsis readable */
// .pagination .page-item .page-link[aria-disabled="true"] {
//   cursor: default;
//   background: transparent;
//   border: none;
//   color: #6c757d;
// }

// /* small screens */
// @media (max-width: 480px) {
//   .pagination .page-link {
//     min-width: 34px;
//     padding: 6px 8px;
//     font-size: 14px;
//   }
// }


//         /* DatePicker styling */
//         .react-datepicker-wrapper {
//           width: 100%;
//         }

//         .react-datepicker__input-container input {
//           width: 100%;
//           padding: 8px 12px;
//           border: 1px solid #ced4da;
//           border-radius: 4px;
//           font-size: 14px;
//         }

//         .react-datepicker__input-container input:focus {
//           border-color: #80bdff;
//           outline: 0;
//           box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
//         }

//         /* Responsive Design */
//         @media (max-width: 768px) {
//           .applicants-container {
//             padding: 16px;
//           }

//           .applicants-header {
//             flex-direction: column;
//             gap: 16px;
//             align-items: stretch;
//           }

//           .header-actions {
//             justify-content: stretch;
//           }

//           .header-actions .btn {
//             flex: 1;
//           }

//           .results-summary {
//             flex-direction: column;
//             gap: 12px;
//             align-items: stretch;
//           }

//           .action-buttons {
//             flex-direction: column;
//           }

//           .action-buttons .btn {
//             width: 100%;
//             margin-bottom: 4px;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default ApplicantsList;


import React, { useState, useEffect } from 'react';
import {
  Table,
  Button,
  Form,
  Row,
  Col,
  Card,
  Badge,
  Modal,
  Pagination,
  Spinner,
  Alert
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ApplicantProfile from './ApplicantProfile';

// Email History Modal Component
const EmailHistoryModal = ({ show, onHide, applicantData, loading }) => {
  if (!applicantData && !loading) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-clock-history me-2"></i>
          Email History
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
            <p className="mt-3 text-muted">Loading email history...</p>
          </div>
        ) : applicantData ? (
          <>
            <div className="mb-4 p-3 bg-light rounded">
              <h6 className="mb-2">{applicantData.applicant.name}</h6>
              <div className="d-flex gap-3 flex-wrap">
                <div>
                  <small className="text-muted">ATS Number:</small>
                  <div><strong>{applicantData.applicant.ats_number}</strong></div>
                </div>
                <div>
                  <small className="text-muted">Email:</small>
                  <div>{applicantData.applicant.email}</div>
                </div>
                <div>
                  <small className="text-muted">Emails Sent:</small>
                  <div>
                    <Badge bg="success">
                      {applicantData.applicant.email_sent_count || 0}
                    </Badge>
                  </div>
                </div>
                <div>
                  <small className="text-muted">Emails Skipped:</small>
                  <div>
                    <Badge bg="warning">
                      {applicantData.applicant.email_skip_count || 0}
                    </Badge>
                  </div>
                </div>
              </div>
            </div>

            {applicantData.history && applicantData.history.length > 0 ? (
              <div className="history-timeline">
                {applicantData.history.map((event, index) => (
                  <div key={index} className="history-item">
                    <div className={`history-icon ${event.status}`}>
                      {event.status === 'success' && <i className="bi bi-check"></i>}
                      {event.status === 'failed' && <i className="bi bi-x"></i>}
                      {event.status === 'skipped' && <i className="bi bi-exclamation"></i>}
                    </div>
                    <div className="history-content">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div>
                          <Badge bg={
                            event.status === 'success' ? 'success' :
                            event.status === 'failed' ? 'danger' : 'warning'
                          }>
                            {event.status.toUpperCase()}
                          </Badge>
                          <Badge bg="secondary" className="ms-2">
                            {event.sent_via || 'unknown'}
                          </Badge>
                        </div>
                        <small className="text-muted">
                          {new Date(event.sent_at).toLocaleString()}
                        </small>
                      </div>
                      {event.subject && (
                        <div className="mb-1">
                          <small className="text-muted">Subject:</small>
                          <div style={{ fontSize: '0.9rem' }}>{event.subject}</div>
                        </div>
                      )}
                      {event.reason && (
                        <div className="text-warning">
                          <small><i className="bi bi-info-circle me-1"></i>{event.reason}</small>
                        </div>
                      )}
                      {event.error && (
                        <div className="text-danger">
                          <small><i className="bi bi-exclamation-triangle me-1"></i>{event.error}</small>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-4 text-muted">
                <i className="bi bi-inbox" style={{ fontSize: '3rem' }}></i>
                <p className="mt-2">No email history available</p>
              </div>
            )}
          </>
        ) : (
          <div className="text-center py-4 text-muted">
            <p>Failed to load email history</p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

// Send Email Modal (simplified version)
const SendEmailModal = ({ show, onHide, domain, selectedApplicants, applicants, onSent, allFiltered }) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [preview, setPreview] = useState({ subject: '', body: '' });
  const [editedSubject, setEditedSubject] = useState('');
  const [editedBody, setEditedBody] = useState('');
  const [dirty, setDirty] = useState(false);
  const [saving, setSaving] = useState(false);
  const [confirming, setConfirming] = useState(false);

  useEffect(() => {
    if (!show) return;
    (async () => {
      try {
        const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
        const res = await axios.get(`${base}/api/email/templates`, { withCredentials: true });
        setTemplates(res.data.templates || []);
      } catch (e) {
        setTemplates([]);
      }
    })();
  }, [show]);

  useEffect(() => {
    const tpl = templates.find(t => t.id === selectedTemplate);
    if (tpl) {
      setPreview({ subject: tpl.subject, body: tpl.body });
      setEditedSubject(tpl.subject || '');
      setEditedBody(tpl.body || '');
      setDirty(false);
    } else {
      setPreview({ subject: '', body: '' });
      setEditedSubject('');
      setEditedBody('');
      setDirty(false);
    }
  }, [selectedTemplate, templates]);

  // Keep ats_number alongside the address so the backend can log each send
  // against the applicant row.
  const applicantRecipients = React.useMemo(() => {
    const sel = new Set(selectedApplicants);
    const base = Array.isArray(allFiltered) && allFiltered.length ? allFiltered : applicants;
    const recipients = [];
    (base || []).forEach(a => {
      const ats = a.ats_number;
      if (!sel.has(ats)) return;
      const email = a.email_id;
      if (!email) return;
      recipients.push({ ats_number: ats, email });
    });
    return recipients;
  }, [selectedApplicants, applicants, allFiltered]);

  const applicantEmails = React.useMemo(
    () => applicantRecipients.map(r => r.email),
    [applicantRecipients]
  );

  const saveTemplate = async () => {
    if (!selectedTemplate) return;
    try {
      setSaving(true);
      const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
      await axios.put(`${base}/api/email/templates/${selectedTemplate}`, {
        subject: editedSubject,
        body: editedBody
      }, { withCredentials: true });
      // reload templates to reflect saved content
      const res = await axios.get(`${base}/api/email/templates`, { withCredentials: true });
      setTemplates(res.data.templates || []);
      setDirty(false);
      toast.success('Template saved');
    } catch (e) {
      toast.error('Failed to save template');
    } finally {
      setSaving(false);
    }
  };

  const confirmSend = async () => {
    try {
      setLoading(true);
      const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
      // Auto-save if dirty so backend uses latest subject/body
      if (selectedTemplate && dirty) {
        try {
          await axios.put(`${base}/api/email/templates/${selectedTemplate}`, {
            subject: editedSubject,
            body: editedBody
          }, { withCredentials: true });
          setDirty(false);
        } catch (e) {
          // If auto-save fails, continue sending with old content
          console.warn('Auto-save failed, sending old content:', e.message);
        }
      }
      const res = await axios.post(`${base}/api/email/send-domain`, {
        domain: domain || 'General',
        template_id: selectedTemplate,
        ats_numbers: applicantRecipients.map(r => r.ats_number),
        email_list: applicantEmails
      }, { withCredentials: true });
      onSent && onSent(res.data);
      setConfirming(false);
      onHide();
    } catch (e) {
      onSent && onSent({ success: false, sent: 0, failed: [{ error: e.message }] });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal show={show && !confirming} onHide={onHide} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Send Emails{domain ? ` — ${domain}` : ''}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="mb-3">
            <Col md={8}>
              <Form.Group>
                <Form.Label>Email Template</Form.Label>
                <Form.Select value={selectedTemplate || ''} onChange={e => setSelectedTemplate(Number(e.target.value))}>
                  <option value="">Select a template</option>
                  {templates.map(t => (
                    <option key={t.id} value={t.id}>{t.template_name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4} className="d-flex align-items-end">
              <div className="text-end w-100">
                <div className="small text-muted">Recipients: {applicantEmails.length}</div>
                <Button variant="primary" size="sm" onClick={() => setConfirming(true)} disabled={!selectedTemplate || applicantEmails.length === 0} className="mt-2 w-100">
                  Send Email
                </Button>
              </div>
            </Col>
          </Row>
          {selectedTemplate && (
            <Card className="mt-2">
              <Card.Body>
                <Form.Group className="mb-3">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control
                    type="text"
                    value={editedSubject}
                    onChange={e => { setEditedSubject(e.target.value); setDirty(true); }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Body</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={8}
                    value={editedBody}
                    onChange={e => { setEditedBody(e.target.value); setDirty(true); }}
                    style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}
                  />
                  <div className="mt-2 d-flex justify-content-between align-items-center">
                    <small className="text-muted">
                      {dirty ? 'Unsaved changes' : 'Saved'}
                    </small>
                    <Button
                      variant="outline-success"
                      size="sm"
                      disabled={!selectedTemplate || saving || !dirty}
                      onClick={saveTemplate}
                    >
                      {saving ? 'Saving...' : 'Save Template'}
                    </Button>
                  </div>
                </Form.Group>
              </Card.Body>
            </Card>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={confirming} onHide={() => setConfirming(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Send</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to send emails to {applicantEmails.length} applicants?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setConfirming(false)}>Cancel</Button>
          <Button variant="primary" onClick={confirmSend} disabled={loading}>
            {loading ? <Spinner animation="border" size="sm" /> : 'Yes, Send'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const ApplicantsList = () => {
  const [applicants, setApplicants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sources, setSources] = useState([]);
  const [filters, setFilters] = useState({
    search: '',
    status: '',
    source: '',
    application_date: null,
    meet_greet_date: null,
    from_date: null,
    to_date: null
  });
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0
  });
  const [selectedApplicants, setSelectedApplicants] = useState([]);
  const [allFiltered, setAllFiltered] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [selectedApplicantAts, setSelectedApplicantAts] = useState(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [domains, setDomains] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState('');
  
  // Email history modal states
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedApplicantHistory, setSelectedApplicantHistory] = useState(null);
  const [loadingHistory, setLoadingHistory] = useState(false);

  useEffect(() => {
    fetchApplicants();
    fetchSources();
  }, [filters, pagination.page]);

  useEffect(() => {
    (async () => {
      try {
        const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
        const res = await axios.get(`${base}/api/domains`, { withCredentials: true });
        setDomains(res.data || []);
      } catch (e) {
        setDomains([]);
      }
    })();
  }, []);

  const fetchEmailHistory = async (atsNumber) => {
    try {
      setLoadingHistory(true);
      setShowHistoryModal(true);
      const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
      const response = await axios.get(
        `${base}/api/applicants/notifications/email-history/${atsNumber}`,
        { withCredentials: true }
      );
      setSelectedApplicantHistory(response.data);
    } catch (error) {
      console.error('Error fetching email history:', error);
      setSelectedApplicantHistory(null);
      toast.error('Failed to load email history');
    } finally {
      setLoadingHistory(false);
    }
  };

  const formatDateToLocal = (date) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const fetchApplicants = async () => {
    try {
      setLoading(true);
      setError(null);

      const params = {
        page: pagination.page,
        limit: pagination.limit,
        ...filters,
        application_date: formatDateToLocal(filters.application_date),
        meet_greet_date: formatDateToLocal(filters.meet_greet_date),
        from_date: formatDateToLocal(filters.from_date),
        to_date: formatDateToLocal(filters.to_date),
      };

      const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
      const response = await axios.get(`${base}/api/applicants`, { params, withCredentials: true });

      if (response.data && response.data.data) {
        setApplicants(response.data.data);
        setAllFiltered(response.data.allFiltered || []);
        setPagination(prev => ({
          ...prev,
          total: response.data.pagination?.total || 0,
          totalPages: response.data.pagination?.totalPages || 0
        }));
      } else {
        setApplicants([]);
        setAllFiltered([]);
        setPagination(prev => ({
          ...prev,
          total: 0,
          totalPages: 0
        }));
      }
    } catch (error) {
      console.error('Error fetching applicants:', error);
      setError('Failed to load applicants. Please try again.');
      toast.error('Failed to load applicants');
    } finally {
      setLoading(false);
    }
  };

  const fetchSources = async () => {
    try {
      const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
      const response = await axios.get(`${base}/api/applicants/sources`, { withCredentials: true });
      setSources(response.data || []);
    } catch (error) {
      console.error('Error fetching sources:', error);
      setSources(['AICTE', 'LinkedIn', 'Instagram', 'Direct', 'Referral', 'Website', 'Other']);
    }
  };

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
    setPagination(prev => ({ ...prev, page: 1 }));
  };

  const handlePageChange = (page) => {
    setPagination(prev => ({ ...prev, page }));
  };

  const handleSelectAllPage = (checked) => {
    if (checked) {
      const pageIds = applicants.map(a => a.ats_number);
      setSelectedApplicants(prev => Array.from(new Set([...prev, ...pageIds])));
    } else {
      const pageIds = new Set(applicants.map(a => a.ats_number));
      setSelectedApplicants(prev => prev.filter(id => !pageIds.has(id)));
    }
  };

  const handleSelectAllFiltered = () => {
    const allIds = allFiltered.map(x => x.ats_number);
    setSelectedApplicants(allIds);
    toast.success(`All ${allIds.length} filtered applicants selected`);
  };

  const handleUnselectAll = () => {
    setSelectedApplicants([]);
  };

  const handleSelectApplicant = (atsNumber, checked) => {
    if (checked) {
      setSelectedApplicants(prev => [...prev, atsNumber]);
    } else {
      setSelectedApplicants(prev => prev.filter(id => id !== atsNumber));
    }
  };

  const handleDeleteApplicant = async (atsNumber) => {
    try {
      const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
      await axios.delete(`${base}/api/applicants/${atsNumber}`, { withCredentials: true });
      toast.success('Applicant deleted successfully');
      fetchApplicants();
    } catch (error) {
      console.error('Error deleting applicant:', error);
      toast.error('Failed to delete applicant');
    }
  };

  const handleViewApplicant = (atsNumber) => {
    setSelectedApplicantAts(atsNumber);
    setShowProfileModal(true);
  };

  const handleBulkDelete = async () => {
    if (selectedApplicants.length === 0) {
      toast.warning('Please select applicants to delete');
      return;
    }

    setDeleteLoading(true);
    try {
      for (const atsNumber of selectedApplicants) {
        const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
        await axios.delete(`${base}/api/applicants/${atsNumber}`, { withCredentials: true });
      }
      toast.success(`${selectedApplicants.length} applicants deleted successfully`);
      setSelectedApplicants([]);
      setShowDeleteModal(false);
      fetchApplicants();
    } catch (error) {
      console.error('Error bulk deleting applicants:', error);
      toast.error('Failed to delete some applicants');
    } finally {
      setDeleteLoading(false);
    }
  };

  const getStatusBadge = (applicant) => {
    if (applicant.rejected) return <Badge bg="danger">Rejected</Badge>;
    if (applicant.left) return <Badge bg="warning" text="dark">Left</Badge>;
    if (applicant.assigned_project) return <Badge bg="success">Assigned</Badge>;
    if (applicant.registered_startupworld) return <Badge bg="info">Registered</Badge>;
    if (applicant.attended_meet_greet) return <Badge bg="primary">Attended</Badge>;
    return <Badge bg="secondary">New</Badge>;
  };

  const getEmailStatusBadge = (emailSentCount, emailSkipCount) => {
    if (emailSkipCount > 0) {
      return <Badge bg="danger">Invalid Email</Badge>;
    }
    if (emailSentCount > 0) {
      return <Badge bg="info">Contacted ({emailSentCount}x)</Badge>;
    }
    return <Badge bg="secondary">No Contact</Badge>;
  };

  const clearFilters = () => {
    setFilters({
      search: '',
      status: '',
      source: '',
      application_date: null,
      meet_greet_date: null,
      from_date: null,
      to_date: null
    });
    setPagination(prev => ({ ...prev, page: 1 }));
  };

  return (
    <div className="applicants-container">
      <style>{`
        .email-log-btn {
          padding: 0.25rem 0.5rem;
          font-size: 0.75rem;
          border-radius: 4px;
          border: 1px solid #6366f1;
          background: transparent;
          color: #6366f1;
          cursor: pointer;
          transition: all 0.2s;
        }
        .email-log-btn:hover {
          background: #6366f1;
          color: white;
        }
        .history-timeline {
          max-height: 400px;
          overflow-y: auto;
          padding: 1rem;
          background: #f9fafb;
          border-radius: 8px;
        }
        .history-item {
          display: flex;
          gap: 1rem;
          margin-bottom: 1.5rem;
          position: relative;
        }
        .history-item::before {
          content: '';
          position: absolute;
          left: 11px;
          top: 30px;
          bottom: -20px;
          width: 2px;
          background: #e5e7eb;
        }
        .history-item:last-child::before {
          display: none;
        }
        .history-icon {
          flex-shrink: 0;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.75rem;
          z-index: 1;
        }
        .history-icon.success {
          background: #10b981;
          color: white;
        }
        .history-icon.failed {
          background: #ef4444;
          color: white;
        }
        .history-icon.skipped {
          background: #f59e0b;
          color: white;
        }
        .history-content {
          flex: 1;
          background: white;
          padding: 0.75rem;
          border-radius: 6px;
          border: 1px solid #e5e7eb;
        }
        .applicants-container {
          padding: 24px;
          background-color: #f8f9fa;
          min-height: 100vh;
        }
        .applicants-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 24px;
          background: white;
          padding: 24px;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        .header-content h1 {
          margin: 0 0 8px 0;
          color: #2c3e50;
          font-size: 28px;
          font-weight: 600;
        }
        .header-content p {
          margin: 0;
          color: #6c757d;
          font-size: 16px;
        }
        .header-actions {
          display: flex;
          gap: 12px;
        }
        .add-btn, .upload-btn {
          padding: 10px 20px;
          font-weight: 500;
        }
        .filters-card {
          margin-bottom: 24px;
          border: none;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        .filters-card .card-body {
          padding: 14px 16px;
          border-radius: 10px;
        }
        .filters-row { row-gap: 8px; }
        .filters-card .form-label { margin-bottom: 4px; font-weight: 600; font-size: 0.85rem; color: #495057; }
        .filters-card .form-control, .filters-card .form-select { height: 38px; padding: 6px 10px; font-size: 0.92rem; }
        .filters-card .btn-clear { height: 38px; }
        .results-summary {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
          padding: 16px 20px;
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        .summary-info {
          display: flex;
          gap: 20px;
          align-items: center;
        }
        .total-count {
          font-weight: 600;
          color: #2c3e50;
        }
        .selected-count {
          color: #007bff;
          font-weight: 500;
        }
        .table-card {
          border: none;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          margin-bottom: 24px;
        }
        .applicants-table {
          margin: 0;
        }
        .applicants-table th {
          background-color: #f8f9fa;
          border-bottom: 2px solid #dee2e6;
          font-weight: 600;
          color: #495057;
          padding: 16px 12px;
        }
        .applicants-table td {
          padding: 16px 12px;
          vertical-align: middle;
          border-bottom: 1px solid #f1f3f4;
        }
        .applicants-table tbody tr:hover {
          background-color: #f8f9fa;
        }
        .applicants-table tbody tr.selected-row {
          background-color: #e6f2ff !important;
        }
        .ats-number {
          font-family: 'Courier New', monospace;
          font-weight: 600;
          color: #007bff;
          background: #e3f2fd;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 14px;
        }
        .applicant-name strong {
          color: #2c3e50;
          font-size: 16px;
        }
        .contact-info {
          font-size: 14px;
        }
        .contact-info .email {
          color: #007bff;
          font-weight: 500;
        }
        .contact-info .phone {
          color: #6c757d;
          margin-top: 2px;
        }
        .domain, .intern-id, .source {
          background: #f8f9fa;
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 14px;
          color: #495057;
        }
        .date {
          color: #6c757d;
          font-size: 14px;
        }
        .action-buttons {
          display: flex;
          gap: 4px;
          flex-wrap: wrap;
        }
        .action-buttons .btn {
          font-size: 12px;
          padding: 4px 8px;
        }
        .loading-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 60px 20px;
          color: #6c757d;
        }
        .empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 60px 20px;
          color: #6c757d;
        }
        .empty-state p {
          margin-bottom: 16px;
          font-size: 18px;
        }
        .pagination-container {
          display: flex;
          justify-content: center;
          margin-top: 24px;
        }
        .pagination .page-link {
          color: #007bff;
          border: 1px solid #dee2e6;
          background: #fff;
          min-width: 40px;
          text-align: center;
          padding: 6px 10px;
          margin: 0 2px;
          border-radius: 6px;
          font-weight: 500;
        }
        .pagination .page-item.active .page-link {
          background-color: #007bff !important;
          border-color: #007bff !important;
          color: #ffffff !important;
          box-shadow: 0 4px 10px rgba(0, 123, 255, 0.15);
        }
        .pagination .page-item.disabled .page-link {
          color: #6c757d;
          background-color: #fff;
          border-color: #dee2e6;
          opacity: 0.9;
        }
        .react-datepicker-wrapper {
          width: 100%;
        }
        .react-datepicker__input-container input {
          width: 100%;
          height: 38px;
          padding: 6px 10px;
          border: 1px solid #ced4da;
          border-radius: 4px;
          font-size: 14px;
        }
        .react-datepicker__input-container input:focus {
          border-color: #80bdff;
          outline: 0;
          box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
        }
        @media (max-width: 768px) {
          .applicants-container {
            padding: 16px;
          }
          .applicants-header {
            flex-direction: column;
            gap: 16px;
            align-items: stretch;
          }
          .header-actions {
            justify-content: stretch;
          }
          .header-actions .btn {
            flex: 1;
          }
          .results-summary {
            flex-direction: column;
            gap: 12px;
            align-items: stretch;
          }
          .action-buttons {
            flex-direction: column;
          }
          .action-buttons .btn {
            width: 100%;
            margin-bottom: 4px;
          }
        }
      `}</style>

      {/* Header */}
      <div className="applicants-header">
        <div className="header-content">
          <h1>Applicants Management</h1>
          <p>Manage and track all applicant information</p>
        </div>
        <div className="header-actions">
          <Link to="/applicants/new">
            <Button variant="primary" className="add-btn">
              Add New Applicant
            </Button>
          </Link>
          <Link to="/bulk-upload">
            <Button variant="outline-primary" className="upload-btn">
              Bulk Upload
            </Button>
          </Link>
          <Link to="/reject-upload">
            <Button variant="outline-danger" className="upload-btn ms-2">
              Upload Rejected
            </Button>
          </Link>
        </div>
      </div>

      {/* Filters */}
      <Card className="filters-card">
        <Card.Body>
          <Row className="filters-row g-2 align-items-end">
            <Col xs={12} sm={6} md={3} lg={4} xl={3}>
              <Form.Group>
                <Form.Label className="filter-label">Search</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Search by name, email, ATS number..."
                  value={filters.search}
                  onChange={(e) => handleFilterChange('search', e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col xs={6} md={2} lg={2} xl={2}>
              <Form.Group>
                <Form.Label className="filter-label">Status</Form.Label>
                <Form.Select
                  value={filters.status}
                  onChange={(e) => handleFilterChange('status', e.target.value)}
                >
                  <option value="">All Status</option>
                  <option value="attended">Attended</option>
                  <option value="registered">Registered</option>
                  <option value="assigned">Assigned</option>
                  <option value="rejected">Rejected</option>
                  <option value="left">Left</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col xs={6} md={2} lg={2} xl={2}>
              <Form.Group>
                <Form.Label className="filter-label">Domain</Form.Label>
                <Form.Select
                  value={filters.domain || ''}
                  onChange={(e) => {
                    setSelectedDomain(e.target.value);
                    handleFilterChange('domain', e.target.value);
                  }}
                >
                  <option value="">All Domains</option>
                  {domains.map(d => (
                    <option key={d} value={d}>{d}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col xs={6} md={2} lg={2} xl={2}>
              <Form.Group>
                <Form.Label className="filter-label">Source</Form.Label>
                <Form.Select
                  value={filters.source}
                  onChange={(e) => handleFilterChange('source', e.target.value)}
                >
                  <option value="">All Sources</option>
                  {sources.map(source => (
                    <option key={source} value={source}>{source}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col xs={6} md={2} lg={2} xl={2}>
              <Form.Group>
                <Form.Label className="filter-label">Application Date</Form.Label>
                <DatePicker
                  selected={filters.application_date}
                  onChange={(date) => handleFilterChange('application_date', date)}
                  className="form-control"
                  placeholderText="Select date"
                  dateFormat="yyyy-MM-dd"
                />
              </Form.Group>
            </Col>

            <Col xs={6} md={2} lg={2} xl={2}>
              <Form.Group>
                <Form.Label className="filter-label">M&G Date</Form.Label>
                <DatePicker
                  selected={filters.meet_greet_date}
                  onChange={(date) => handleFilterChange('meet_greet_date', date)}
                  className="form-control"
                  placeholderText="Select date"
                  dateFormat="yyyy-MM-dd"
                />
              </Form.Group>
            </Col>

            <Col xs={6} md={2} lg={2} xl={2}>
              <Form.Group>
                <Form.Label className="filter-label">From Date</Form.Label>
                <DatePicker
                  selected={filters.from_date}
                  onChange={(date) => handleFilterChange('from_date', date)}
                  className="form-control"
                  placeholderText="Select from date"
                  dateFormat="yyyy-MM-dd"
                />
              </Form.Group>
            </Col>

            <Col xs={6} md={2} lg={2} xl={2}>
              <Form.Group>
                <Form.Label className="filter-label">To Date</Form.Label>
                <DatePicker
                  selected={filters.to_date}
                  onChange={(date) => handleFilterChange('to_date', date)}
                  className="form-control"
                  placeholderText="Select to date"
                  dateFormat="yyyy-MM-dd"
                />
              </Form.Group>
            </Col>

            <Col xs={12} md={2} lg={2} xl={1} className="d-flex justify-content-end">
              <div className="w-100 d-grid">
                <Button
                  variant="outline-secondary"
                  onClick={clearFilters}
                  className="btn-clear"
                >
                  Clear
                </Button>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Results Summary */}
      <div className="results-summary">
        <div className="summary-info">
          <span className="total-count">
            Total: {pagination.total} applicants
          </span>
          <span className="selected-count">
            Selected: {selectedApplicants.length}
          </span>
        </div>
        <div className="bulk-actions d-flex gap-2">
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={handleSelectAllFiltered}
            disabled={(allFiltered.length === 0) || selectedApplicants.length === allFiltered.length}
          >
            Select All Filtered ({allFiltered.length})
          </Button>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={handleUnselectAll}
            disabled={selectedApplicants.length === 0}
          >
            Unselect All
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={() => setShowEmailModal(true)}
            disabled={selectedApplicants.length === 0}
          >
            Send Email
          </Button>
          <Button
            variant="outline-danger"
            size="sm"
            onClick={() => setShowDeleteModal(true)}
            disabled={selectedApplicants.length === 0}
          >
            Delete Selected
          </Button>
        </div>
      </div>

      {/* Applicants Table */}
      <Card className="table-card">
        <Card.Body className="p-0">
          {loading ? (
            <div className="loading-container">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <p>Loading applicants...</p>
            </div>
          ) : error ? (
            <Alert variant="danger" className="m-3">
              {error}
            </Alert>
          ) : applicants.length === 0 ? (
            <div className="empty-state">
              <p>No applicants found</p>
              <Link to="/applicants/new">
                <Button variant="primary">Add First Applicant</Button>
              </Link>
            </div>
          ) : (
            <div className="table-responsive">
              <Table hover className="applicants-table">
                <thead>
                  <tr>
                    <th>
                      <Form.Check
                        type="checkbox"
                        checked={applicants.every(a => selectedApplicants.includes(a.ats_number)) && applicants.length>0}
                        onChange={(e) => handleSelectAllPage(e.target.checked)}
                      />
                    </th>
                    <th>ATS Number</th>
                    <th>Name</th>
                    <th>Contact</th>
                    <th>Domain</th>
                    <th>Source</th>
                    <th>Application Date</th>
                    <th>Status</th>
                    <th>Email Log</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {applicants.map((applicant) => (
                    <tr key={applicant.id} className={selectedApplicants.includes(applicant.ats_number) ? 'selected-row' : ''}>
                      <td>
                        <Form.Check
                          type="checkbox"
                          checked={selectedApplicants.includes(applicant.ats_number)}
                          onChange={(e) =>
                            handleSelectApplicant(applicant.ats_number, e.target.checked)
                          }
                        />
                      </td>
                      <td>
                        <span className="ats-number">{applicant.ats_number}</span>
                      </td>
                      <td>
                        <div className="applicant-name">
                          <strong>
                            {applicant.first_name} {applicant.last_name}
                          </strong>
                        </div>
                      </td>
                      <td>
                        <div className="contact-info">
                          <div className="email">{applicant.email_id}</div>
                          <div className="phone">
                            {applicant.country_code} {applicant.phone_number}
                          </div>
                          {applicant.last_email_sent_at && (
                            <small className="text-muted">
                              Last sent: {new Date(applicant.last_email_sent_at).toLocaleDateString()}
                            </small>
                          )}
                        </div>
                      </td>
                      <td>
                        <span className="domain">{applicant.domain || 'N/A'}</span>
                      </td>
                      <td>
                        <span className="source">{applicant.source || 'Unknown'}</span>
                      </td>
                      <td>
                        <span className="date">{applicant.application_date}</span>
                      </td>
                      <td>{getStatusBadge(applicant)}</td>
                      <td>
                        <div className="d-flex flex-column gap-1 align-items-start">
                          <div>
                            {applicant.email_sent_count > 0 && (
                              <Badge bg="success" className="me-1">
                                <i className="bi bi-send-check me-1"></i>
                                {applicant.email_sent_count}
                              </Badge>
                            )}
                            {applicant.email_skip_count > 0 && (
                              <Badge bg="warning">
                                <i className="bi bi-x-circle me-1"></i>
                                {applicant.email_skip_count}
                              </Badge>
                            )}
                            {(!applicant.email_sent_count || applicant.email_sent_count === 0) && (!applicant.email_skip_count || applicant.email_skip_count === 0) && (
                              <Badge bg="secondary">No activity</Badge>
                            )}
                          </div>
                          {((applicant.email_sent_count && applicant.email_sent_count > 0) || (applicant.email_skip_count && applicant.email_skip_count > 0)) && (
                            <button
                              className="email-log-btn"
                              onClick={() => fetchEmailHistory(applicant.ats_number)}
                            >
                              <i className="bi bi-clock-history me-1"></i>
                              View History
                            </button>
                          )}
                        </div>
                      </td>
                      <td>
                        <div className="action-buttons">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => handleViewApplicant(applicant.ats_number)}
                          >
                            View
                          </Button>
                          <Link to={`/applicants/${applicant.ats_number}/edit`}>
                            <Button variant="outline-secondary" size="sm">Edit</Button>
                          </Link>
                          {applicant.resume_link && (
                            <Button
                              variant="outline-info"
                              size="sm"
                              href={applicant.resume_link}
                              target="_blank"
                            >
                              Resume
                            </Button>
                          )}
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleDeleteApplicant(applicant.ats_number)}
                          >
                            Delete
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>
      </Card>

      {/* Pagination */}
      {pagination.totalPages > 1 && (
        <div className="pagination-container">
          <Pagination>
            <Pagination.First
              onClick={() => handlePageChange(1)}
              disabled={pagination.page === 1}
            />
            <Pagination.Prev
              onClick={() => handlePageChange(Math.max(1, pagination.page - 1))}
              disabled={pagination.page === 1}
            />
            {(() => {
              const pages = [];
              const maxVisible = 5;
              let start = Math.max(1, pagination.page - Math.floor(maxVisible / 2));
              let end = start + maxVisible - 1;

              if (end > pagination.totalPages) {
                end = pagination.totalPages;
                start = Math.max(1, end - maxVisible + 1);
              }

              if (start > 1) {
                pages.push(
                  <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
                    {1}
                  </Pagination.Item>
                );
                if (start > 2) {
                  pages.push(
                    <Pagination.Ellipsis key="start-ellipsis" disabled />
                  );
                }
              }

              for (let p = start; p <= end; p++) {
                pages.push(
                  <Pagination.Item
                    key={p}
                    active={p === pagination.page}
                    onClick={() => handlePageChange(p)}
                  >
                    {p}
                  </Pagination.Item>
                );
              }

              if (end < pagination.totalPages) {
                if (end < pagination.totalPages - 1) {
                  pages.push(
                    <Pagination.Ellipsis key="end-ellipsis" disabled />
                  );
                }
                pages.push(
                  <Pagination.Item
                    key={pagination.totalPages}
                    onClick={() => handlePageChange(pagination.totalPages)}
                  >
                    {pagination.totalPages}
                  </Pagination.Item>
                );
              }

              return pages;
            })()}
            <Pagination.Next
              onClick={() => handlePageChange(Math.min(pagination.totalPages, pagination.page + 1))}
              disabled={pagination.page === pagination.totalPages}
            />
            <Pagination.Last
              onClick={() => handlePageChange(pagination.totalPages)}
              disabled={pagination.page === pagination.totalPages}
            />
          </Pagination>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete {selectedApplicants.length} selected applicant(s)?
          This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleBulkDelete}
            disabled={deleteLoading}
          >
            {deleteLoading ? <Spinner animation="border" size="sm" /> : 'Delete'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Applicant Profile Modal */}
      <ApplicantProfile
        show={showProfileModal}
        onHide={() => setShowProfileModal(false)}
        atsNumber={selectedApplicantAts}
      />

      {/* Email History Modal */}
      <EmailHistoryModal
        show={showHistoryModal}
        onHide={() => setShowHistoryModal(false)}
        applicantData={selectedApplicantHistory}
        loading={loadingHistory}
      />

      {/* Send Email Modal */}
      <SendEmailModal
        show={showEmailModal}
        onHide={() => setShowEmailModal(false)}
        domain={selectedDomain}
        selectedApplicants={selectedApplicants}
        applicants={applicants}
        allFiltered={allFiltered}
        onSent={(res) => {
          if (res && res.success) {
            toast.success(`✅ Email successfully sent to ${res.sent} applicants.`);
            fetchApplicants(); // Refresh to update email counts
          } else if (res) {
            const failed = (res.failed || []).map(f => f.to).filter(Boolean).join(', ');
            toast.error(`Some emails failed. ${failed ? 'Failed: ' + failed : ''}`);
          }
        }}
      />
    </div>
  );
};

export default ApplicantsList;